<template>
  <div class="control__order__food__wrapper">
    <h3>Контроль заказов питания</h3>
    <form @submit.prevent="func_get_data">
      <div class="form__group">
        <label>Школа</label>
        <v-select
          label="school"
          :options="school_list"
          v-model="school_value"
          @option:selecting="func_get_class_list"
        />
      </div>
      <div class="form__group">
        <label>Класс</label>
        <v-select
          label="class"
          :options="class_list"
          v-model="class_value"
          @option:selecting="func_clear_order()"
        />
      </div>
      <div class="form__group">
        <label>Дата</label>
        <div class="date__flex">
          <input type="date" required v-model="date_start" />
          <span>-</span>
          <input type="date" required v-model="date_end" />
        </div>
      </div>
      <button class="send">Сформировать отчет</button>
    </form>
    <div class="table__result" v-if="order_food.length > 0">
      <table class="order__food" border="1">
        <thead>
          <tr>
            <th rowspan="2">№ПП</th>
            <th rowspan="2">Логин</th>
            <th rowspan="2">Дата заказа</th>
            <th rowspan="2">Город</th>
            <th rowspan="2">Школа</th>
            <th rowspan="2">Класс</th>
            <th rowspan="2" v-if="class_value">ФИО ученика</th>
            <th colspan="3">Бесплатное питание</th>
            <th colspan="3">Платное питание</th>
            <th colspan="3">Льготное питание</th>
            <th colspan="2">Льготное питание + доплата</th>
            <th colspan="3">ГПД</th>
          </tr>
          <tr>
            <th class="color1">Завтрак</th>
            <th class="color1">Обед</th>
            <th class="color1">Полдник</th>
            <th class="color2">Завтрак</th>
            <th class="color2">Обед</th>
            <th class="color2">Полдник</th>
            <th class="">Завтрак</th>
            <th class="">Обед</th>
            <th class="">Полдник</th>
            <th class="color3">Завтрак</th>
            <th class="color3">Обед</th>
            <th class="color4">Платное</th>
            <th class="color4">Льготника</th>
            <th class="color4">Льготника с доплатой</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in order_food" :key="index">
            <td :style="{ background: func_get_color(item) }">
              {{ index + 1 }}
            </td>
            <td>{{ item.login }}</td>

            <td>
              {{
                new Date(item.datetime).toLocaleDateString() +
                ' ' +
                new Date(item.datetime).toLocaleTimeString()
              }}
            </td>
            <td>{{ item.city }}</td>
            <td>{{ item.school }}</td>
            <td>{{ item.class }}</td>
            <td v-if="class_value">{{ item.FIO }}</td>
            <td class="color1">
              <input
                type="checkbox"
                v-model="item.bp"
                disabled
                v-if="class_value"
              />
              <span v-else>{{ item.bp }}</span>
            </td>
            <td class="color1">
              <input
                type="checkbox"
                v-model="item.bpO"
                disabled
                v-if="class_value"
              />
              <span v-else>{{ item.bpO }}</span>
            </td>
            <td class="color1">
              <input
                type="checkbox"
                v-model="item.bpP"
                disabled
                v-if="class_value"
              />
              <span v-else>{{ item.bpP }}</span>
            </td>
            <td class="color2">
              <input
                type="checkbox"
                v-model="item.priznak"
                disabled
                v-if="class_value"
              />
              <span v-else>{{ item.priznak }}</span>
            </td>
            <td class="color2">
              <input
                type="checkbox"
                v-model="item.priznakO"
                disabled
                v-if="class_value"
              />
              <span v-else>{{ item.priznakO }}</span>
            </td>
            <td class="color2">
              <input
                type="checkbox"
                v-model="item.priznakP"
                disabled
                v-if="class_value"
              />
              <span v-else>{{ item.priznakP }}</span>
            </td>
            <td style="text-align: center; width: 52px">
              <input
                type="checkbox"
                v-model="item.lgZ1"
                disabled
                v-if="class_value"
              />
              <span v-else>{{ item.lgZ1 }}</span>
            </td>
            <td style="text-align: center; width: 52px">
              <input
                type="checkbox"
                v-model="item.lgO1"
                disabled
                v-if="class_value"
              />
              <span v-else>{{ item.lgO1 }}</span>
            </td>
            <td style="text-align: center; width: 52px">
              <input
                type="checkbox"
                v-model="item.lgP1"
                disabled
                v-if="class_value"
              />
              <span v-else>{{ item.lgP1 }}</span>
            </td>
            <td class="color3">
              <input
                type="checkbox"
                v-model="item.lgzav"
                disabled
                v-if="class_value"
              />
              <span v-else>{{ item.lgzav }}</span>
            </td>
            <td class="color3">
              <input
                type="checkbox"
                v-model="item.lgob"
                disabled
                v-if="class_value"
              />
              <span v-else>{{ item.lgob }}</span>
            </td>
            <td style="text-align: center" class="color4">
              <input
                type="checkbox"
                v-model="item.gpd"
                disabled
                v-if="class_value"
              />
              <span v-else>{{ item.gpd }}</span>
            </td>
            <td style="text-align: center" class="color4">
              <input
                type="checkbox"
                v-model="item.gpdP"
                disabled
                v-if="class_value"
              />
              <span v-else>{{ item.gpdP }}</span>
            </td>
            <td style="text-align: center" class="color4">
              <input
                type="checkbox"
                v-model="item.gpdPD"
                disabled
                v-if="class_value"
              />
              <span v-else>{{ item.gpdPD }}</span>
            </td>
          </tr>
          <tr>
            <th></th>
            <th>Итого:</th>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
            <th v-if="class_value"></th>
            <th>{{ func_get_summ(1) }}</th>
            <th>{{ func_get_summ(2) }}</th>
            <th>{{ func_get_summ(14) }}</th>
            <th>{{ func_get_summ(3) }}</th>
            <th>{{ func_get_summ(4) }}</th>
            <th>{{ func_get_summ(5) }}</th>
            <th>{{ func_get_summ(6) }}</th>
            <th>{{ func_get_summ(7) }}</th>
            <th>{{ func_get_summ(8) }}</th>
            <th>{{ func_get_summ(9) }}</th>
            <th>
              {{ func_get_summ(10) }}
            </th>
            <th>
              {{ func_get_summ(11) }}
            </th>
            <th>
              {{ func_get_summ(12) }}
            </th>
            <th>
              {{ func_get_summ(13) }}
            </th>
          </tr>
        </tbody>
      </table>
    </div>
    <div
      class="table__clear"
      v-if="order_food.length === 0 && progress === false"
    >
      Ничего не найдено
    </div>
  </div>
</template>

<script>
import schoolListMixin from '@/mixins/schoolList';
import { getControlOrderFood } from '@/api/endpoints';
import { parseBoolRows } from '@/utils/flags';
import { balanceColor } from '@/utils/balance';
import { sumItems } from '@/utils/sum';

const FLAG_FIELDS = [
  'bp',
  'bpO',
  'bpP',
  'priznak',
  'priznakO',
  'priznakP',
  'lgZ1',
  'lgO1',
  'lgP1',
  'lgzav',
  'lgob',
  'gpd',
  'gpdP',
  'gpdPD',
];
const SUMM_KEYS = {
  1: 'bp',
  2: 'bpO',
  3: 'priznak',
  4: 'priznakO',
  5: 'priznakP',
  6: 'lgZ1',
  7: 'lgO1',
  8: 'lgP1',
  9: 'lgzav',
  10: 'lgob',
  11: 'gpd',
  12: 'gpdP',
  13: 'gpdPD',
  14: 'bpP',
};

export default {
  mixins: [schoolListMixin],
  data() {
    return {
      school_list: [],
      class_list: [],
      school_value: null,
      class_value: null,
      date_start: '',
      date_end: '',
      order_food: [],
      progress: true,
    };
  },
  watch: {
    class_value(val) {
      if (!val) {
        this.order_food = [];
        this.progress = true;
      }
    },
  },
  methods: {
    func_clear_order() {
      this.order_food = [];
      this.progress = true;
    },
    func_get_data() {
      if (!this.school_value) {
        window.soundClick();
        this.$notify({
          group: 'foo',
          title: 'Ошибка',
          text: 'Выберите школу',
          type: 'error',
        });
        return;
      }
      this.progress = true;
      getControlOrderFood({
        school_id: this.school_value.school_id,
        class_id: this.class_value ? this.class_value.class_id : '',
        date_start: this.date_start,
        date_end: this.date_end,
      }).then(result => {
          if (!result) {
            this.progress = false;
            return;
          }
          if (this.class_value) {
            parseBoolRows(result, FLAG_FIELDS);
          }
          this.order_food = result;

          this.progress = false;
        });
    },
    func_get_color(obj) {
      if (!obj) return;
      return balanceColor(obj.balance);
    },
    func_get_summ(num) {
      return sumItems(this.order_food, num, SUMM_KEYS, {
        numeric: !this.class_value,
      });
    },
  },
  mounted() {
    this.func_get_school_list();
  },
};
</script>

<style></style>
